// extracted by mini-css-extract-plugin
export default {"addNewPostContainer":"AddNewPost_addNewPostContainer__4ryKZ","customSelectNew":"AddNewPost_customSelectNew__KpJ-C"};